import { css } from 'styled-components';
/**
 * Набор часто встречающихся скруглений.
 */

export var radiuses = {
  250: 15.625,
  32: 2,
  28: 1.75,
  24: 1.5,
  20: 1.25,
  18: 1.125,
  16: 1,
  14: 0.875,
  12: 0.75,
  8: 0.5,
  0: 0
};

/**
 * Миксин скругленности.
 */
export var applyRoundness = function applyRoundness(_ref) {
  var roundness = _ref.roundness;
  return css(["border-radius:", "rem;"], radiuses[roundness]);
};